import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.028 17c-3.85-.045-7.001-3.08-7.028-6.967C2.975 6.159 6.136 2.983 9.994 3c3.916.018 6.982 3.12 7.006 6.922.024 3.93-3.088 7.021-6.972 7.078m5.593-7.001c.047-3.118-2.483-5.573-5.58-5.612-3.035-.038-5.632 2.42-5.676 5.521a5.647 5.647 0 0 0 5.63 5.699c2.756.037 5.649-2.238 5.626-5.608"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.12 8.79c0-.535-.008-1.07.003-1.606a.676.676 0 0 1 .952-.627c.248.102.424.388.424.699 0 .866.003 1.732-.003 2.598 0 .15.047.24.174.317.64.383 1.277.773 1.913 1.16.067.041.135.083.196.132.292.233.357.58.17.882-.194.31-.55.425-.877.25-.41-.224-.806-.473-1.206-.715-.432-.261-.856-.533-1.294-.784-.314-.18-.467-.43-.46-.795.008-.504.002-1.008.002-1.512z"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=ClockIcon20.js.map